(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () {
    /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
    const __meta__ = {
        id: "polifill",
        name: "Polifill",
        category: "web",
        description: "A polifill for kendo. Typically injected in messages and cultures.",
        depends: [ ],
    };

    if (!window.kendo) {
        console.error("kendo is not loaded.", "Ensure that kendo scripts are loaded before this script.");
    }

    (function( window, undefined$1 ) {
        kendo.cultures["zh-SG"] = {
            name: "zh-SG",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ",",
                ".": ".",
                groupSize: [3],
                percent: {
                    pattern: ["-n%","n%"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Singapore Dollar",
                    abbr: "SGD",
                    pattern: ["-$n","$n"],
                    decimals: 2,
                    ",": ",",
                    ".": ".",
                    groupSize: [3],
                    symbol: "$"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],
                        namesAbbr: ["周日","周一","周二","周三","周四","周五","周六"],
                        namesShort: ["日","一","二","三","四","五","六"]
                    },
                    months: {
                        names: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],
                        namesAbbr: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]
                    },
                    AM: ["上午","上午","上午"],
                    PM: ["下午","下午","下午"],
                    patterns: {
                        d: "d/M/yyyy",
                        D: "yyyy'年'M'月'd'日'",
                        F: "yyyy'年'M'月'd'日' tt h:mm:ss",
                        g: "d/M/yyyy tt h:mm",
                        G: "d/M/yyyy tt h:mm:ss",
                        m: "M月d日",
                        M: "M月d日",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "tt h:mm",
                        T: "tt h:mm:ss",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "yyyy'年'M'月'",
                        Y: "yyyy'年'M'月'"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 0
                }
            }
        };
    })();

}));
